import React from "react";
import SidebarIcon from "./SidebarIcon";
import { useLocation } from "react-router-dom";

const Sidebar = () => {
  let location = useLocation();

  return (
    <div className="sidebar-wrap user">
      <SidebarIcon
        link="/admin-panel"
        active={location.pathname === "/admin-panel" && "active"}
        icon={
          <svg
            width="46"
            height="52"
            viewBox="0 0 46 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="home"
          >
            <path
              d="M9.86338 9.9798L22.7156 0.394043L35.2138 9.72467L44.9868 17.153V50.7199H26.2787V33.1623H22.7018L19.0587 33.1271V50.6951L0.284424 50.7199V17.1584L9.86338 9.9798Z"
              fill="#09C4FF"
            />
            <path
              d="M4.38912 46.5896H14.9219V29.0351H30.3699V46.5896H40.9026V19.2045L22.6459 5.51197L4.38912 19.2045V46.5896ZM0.176025 50.8027V17.098L22.6459 0.245605L45.1157 17.098V50.8027H26.1568V33.2482H19.1349V50.8027H0.176025Z"
              fill="#09C4FF"
            />
          </svg>
        }
      />

      <SidebarIcon
        link="/customer-listing"
        active={location.pathname === "/customer-listing" && "active"}
        icon={
          <svg
            width="71"
            height="71"
            viewBox="0 0 71 71"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="9.63086"
              y="10.4355"
              width="52.5"
              height="53.9583"
              rx="6"
              fill="white"
              fillOpacity="0.5"
            />
            <path
              d="M35.8444 52.7272C32.6604 52.7272 29.61 53.2498 26.6934 54.2949C23.7767 55.3401 21.0059 56.9807 18.3809 59.2168V60.0189H53.3809V59.6543C50.9503 57.4668 48.2159 55.7654 45.1777 54.5501C42.1395 53.3349 39.0284 52.7272 35.8444 52.7272ZM14.0059 57.1022C16.8253 54.3314 20.1187 52.1803 23.8861 50.6491C27.6534 49.1178 31.6517 48.3522 35.8809 48.3522C40.11 48.3522 44.0961 49.1178 47.8392 50.6491C51.5823 52.1803 54.8878 54.3314 57.7559 57.1022V14.8105H14.0059V57.1022ZM35.8809 41.4981C33.11 41.4981 30.7645 40.538 28.8444 38.6178C26.9243 36.6977 25.9642 34.3522 25.9642 31.5814C25.9642 28.8106 26.9243 26.4651 28.8444 24.5449C30.7645 22.6248 33.11 21.6647 35.8809 21.6647C38.6517 21.6647 40.9972 22.6248 42.9173 24.5449C44.8375 26.4651 45.7975 28.8106 45.7975 31.5814C45.7975 34.3522 44.8375 36.6977 42.9173 38.6178C40.9972 40.538 38.6517 41.4981 35.8809 41.4981ZM35.898 37.1231C37.4421 37.1231 38.7489 36.5826 39.8184 35.5018C40.8878 34.4208 41.4225 33.1083 41.4225 31.5643C41.4225 30.0201 40.8821 28.7133 39.8012 27.6439C38.7203 26.5744 37.4078 26.0397 35.8637 26.0397C34.3196 26.0397 33.0128 26.5801 31.9434 27.661C30.8739 28.7419 30.3392 30.0544 30.3392 31.5985C30.3392 33.1427 30.8796 34.4494 31.9605 35.5189C33.0414 36.5883 34.3539 37.1231 35.898 37.1231ZM14.0059 64.3939C12.8392 64.3939 11.8184 63.9564 10.9434 63.0814C10.0684 62.2064 9.63086 61.1856 9.63086 60.0189V14.8105C9.63086 13.6439 10.0684 12.623 10.9434 11.748C11.8184 10.873 12.8392 10.4355 14.0059 10.4355H18.7454L23.485 10.4355L48.2767 10.4355H53.0163H57.7559C58.9225 10.4355 59.9434 10.873 60.8184 11.748C61.6934 12.623 62.1309 13.6439 62.1309 14.8105V60.0189C62.1309 61.1856 61.6934 62.2064 60.8184 63.0814C59.9434 63.9564 58.9225 64.3939 57.7559 64.3939H14.0059ZM35.8809 60.0189H53.3809H18.3809H35.8809Z"
              fill="#09C4FF"
            />
          </svg>
        }
      />

      <SidebarIcon
        link="/admin-reports"
        active={location.pathname === "/admin-reports" && "active"}
        icon={
          <svg
            width="61"
            height="61"
            viewBox="0 0 61 61"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.7339 11.3438C10.7339 8.03004 13.4202 5.34375 16.7339 5.34375H34.4151C36.0928 5.34375 37.6938 6.04616 38.8299 7.28062L43.6067 12.4709L48.7937 17.2376C50.0302 18.3738 50.7339 19.9762 50.7339 21.6555V49.3438C50.7339 52.6575 48.0476 55.3438 44.7339 55.3438H16.7339C13.4202 55.3438 10.7339 52.6575 10.7339 49.3438V11.3438Z"
              fill="white"
              fillOpacity="0"
            />
            <path
              d="M19.0732 47.0042V44.5424L21.0167 42.599V47.0042H19.0732ZM24.4178 47.0042V39.3599L26.3612 37.4164V47.0042H24.4178ZM29.7623 47.0042V37.4164L31.7057 39.3923V47.0042H29.7623ZM35.1068 47.0042V39.3923L37.0503 37.4488V47.0042H35.1068ZM40.4513 47.0042V34.1773L42.3948 32.2338V47.0042H40.4513ZM19.0732 39.3599V36.6066L28.1427 27.6019L33.3253 32.7845L42.3948 23.6826V26.4359L33.3253 35.5377L28.1427 30.3552L19.0732 39.3599Z"
              fill="#09C4FF"
            />
            <path
              d="M14.4839 55.3438C13.4839 55.3438 12.6089 54.9688 11.8589 54.2188C11.1089 53.4688 10.7339 52.5938 10.7339 51.5938V9.09375C10.7339 8.09375 11.1089 7.21875 11.8589 6.46875C12.6089 5.71875 13.4839 5.34375 14.4839 5.34375H37.0464L50.7339 19.0312V51.5938C50.7339 52.5938 50.3589 53.4688 49.6089 54.2188C48.8589 54.9688 47.9839 55.3438 46.9839 55.3438H14.4839ZM35.1714 20.7188V9.09375H14.4839V51.5938H46.9839V20.7188H35.1714Z"
              fill="#09C4FF"
            />
          </svg>
        }
      />

      <SidebarIcon
        link="/device-listing"
        active={location.pathname === "/device-listing" && "active"}
        icon={
          <svg
            width="71"
            height="71"
            viewBox="0 0 71 71"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27.3306 42.2137V31.9598H24.4083V27.667H46.2143V31.9484H43.3438V42.1627H58.662V58.9618H11.9954V42.2137H27.3306Z"
              fill="white"
              fillOpacity="0"
            />
            <path
              d="M33.1412 25.4201V13.7534H21.4745V9.37842H49.1829V13.7534H37.5162V25.4201H33.1412ZM11.9954 58.9618V42.1909H16.3704H27.3079V31.9826H24.3912V27.6076H46.2662V31.9826H43.3495V42.1909H54.287H58.662V58.9618H54.287H16.3704H11.9954ZM16.3704 54.5868H54.287V46.5659H38.9745V31.9826H31.6829V46.5659H16.3704V54.5868Z"
              fill="#09C4FF"
            />
          </svg>
        }
      />

      <SidebarIcon
        link="/dealer-listing"
        active={
          location.pathname === "/dealer-listing" ||
          (location.pathname === "/dealer-listing/dealer-detail" && "active")
        }
        icon={
          <svg
            width="68"
            height="69"
            viewBox="0 0 68 69"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="dealer-icon"
          >
            <rect
              x="0.0883789"
              y="0.539062"
              width="67.6826"
              height="67.6826"
              rx="4.72204"
              fill="white"
              fillOpacity="0"
              className="white-rect"
            />
            <rect
              x="2.4494"
              y="2.90008"
              width="62.9606"
              height="62.9606"
              rx="2.36102"
              stroke="#09C4FF"
              stroke-opacity="1"
              strokeWidth="4.72204"
              className="black-rect"
            />
            <path
              d="M4.75781 63.5293L4.75805 61.2853C4.75805 59.7453 5.15405 58.3483 5.94605 57.0943C6.73805 55.8403 7.83804 54.9053 9.24603 54.2893C12.458 52.8813 15.351 51.8693 17.925 51.2533C20.499 50.6373 23.15 50.3293 25.878 50.3293C28.606 50.3293 31.2459 50.6373 33.7979 51.2533C36.3499 51.8693 39.2319 52.8813 42.4439 54.2893C43.8519 54.9053 44.9629 55.8403 45.7769 57.0943C46.5909 58.3483 46.9979 59.7453 46.9979 61.2853L46.9976 63.5293H25.8777H4.75781ZM50.9579 63.5293V61.2853C50.9579 58.5133 50.2539 56.2363 48.8459 54.4543C47.4379 52.6723 45.5899 51.2313 43.3019 50.1313C46.3379 50.4833 49.1979 51.0003 51.8819 51.6823C54.5658 52.3643 56.7438 53.1453 58.4158 54.0253C59.8678 54.8613 61.0118 55.8953 61.8478 57.1273C62.6838 58.3593 63.1018 59.7453 63.1018 61.2853V63.5293H57.0298H50.9579ZM25.878 46.3033C22.974 46.3033 20.598 45.3793 18.75 43.5313C16.902 41.6834 15.978 39.3074 15.978 36.4034C15.978 33.4994 16.902 31.1234 18.75 29.2754C20.598 27.4274 22.974 26.5034 25.878 26.5034C28.782 26.5034 31.1579 27.4274 33.0059 29.2754C34.8539 31.1234 35.7779 33.4994 35.7779 36.4034C35.7779 39.3074 34.8539 41.6834 33.0059 43.5313C31.1579 45.3793 28.782 46.3033 25.878 46.3033ZM49.6379 36.4034C49.6379 39.3074 48.7139 41.6834 46.8659 43.5313C45.0179 45.3793 42.6419 46.3033 39.7379 46.3033C39.2539 46.3033 38.7149 46.2703 38.1209 46.2043C37.5269 46.1383 36.9879 46.0173 36.5039 45.8413C37.5599 44.7413 38.3629 43.3883 38.9129 41.7824C39.4629 40.1764 39.7379 38.3834 39.7379 36.4034C39.7379 34.4234 39.4629 32.6744 38.9129 31.1564C38.3629 29.6384 37.5599 28.2414 36.5039 26.9654C36.9879 26.8334 37.5269 26.7234 38.1209 26.6354C38.7149 26.5474 39.2539 26.5034 39.7379 26.5034C42.6419 26.5034 45.0179 27.4274 46.8659 29.2754C48.7139 31.1234 49.6379 33.4994 49.6379 36.4034ZM8.71804 63.5293H43.0379V61.2853C43.0379 60.5813 42.8289 59.8993 42.4109 59.2393C41.9929 58.5793 41.4759 58.1173 40.8599 57.8533C37.6919 56.4453 35.0299 55.4993 32.8739 55.0153C30.7179 54.5313 28.386 54.2893 25.878 54.2893C23.37 54.2893 21.027 54.5313 18.849 55.0153C16.671 55.4993 13.998 56.4453 10.83 57.8533C10.214 58.1173 9.70803 58.5793 9.31203 59.2393C8.91604 59.8993 8.71804 60.5813 8.71804 61.2853V63.5293ZM25.878 42.3434C27.594 42.3434 29.013 41.7824 30.1349 40.6604C31.2569 39.5384 31.8179 38.1194 31.8179 36.4034C31.8179 34.6874 31.2569 33.2684 30.1349 32.1464C29.013 31.0244 27.594 30.4634 25.878 30.4634C24.162 30.4634 22.743 31.0244 21.621 32.1464C20.499 33.2684 19.938 34.6874 19.938 36.4034C19.938 38.1194 20.499 39.5384 21.621 40.6604C22.743 41.7824 24.162 42.3434 25.878 42.3434Z"
              fill="#09C4FF"
              fillOpacity="1"
              className="black-path"
            />
          </svg>
        }
      />
    </div>
  );
};

export default Sidebar;
